<div class="media-card" *ngIf="media() as media">
  <div class="media-container">
    <div class="media-cover-container">
      @let context = {
        cover: mediaService.getCoverSrc(media),
        overlay: media.overlay?.src,
        height: forcedCoverHeight() || mediaService.getCoverHeight(media, defaultCoverHeight()),
        folder: Media.isFolder(media)
      };
      <div class="media-cover" 
          [style.backgroundColor]="backgroundColor()" 
          [class.folder]="context.folder">
        <div [style.padding-top.%]="context.height">
          <div class="cover" (click)="onCoverClick($event)">
            <img #cover
                  *ngIf="context.cover as src"
                  [src]="src | serverAuthUrl"
                  draggable="false"
                  onload="this.style.opacity='1'"/>
            <img *ngIf="context.overlay as src"
                  [src]="src | serverAuthUrl"
                  draggable="false"
                  onload="this.style.opacity='1'"/>
            <!-- <media-icon *ngIf="media.type != 'conference'" 
              [media]="media" 
              [ngClass]="download() ? 'download' : 'no-download'">
            </media-icon> -->
            <!--TODO: move media.type != 'conference' to media page and use mediaTypeIcon only-->
            <media-icon *ngIf="mediaTypeIcon() && media.type != 'conference'" [media]="media" >
            </media-icon>
            @if (download()) {
              <div class="download" aria-label="download">
                <svg cIcon name="cisCloudDownload"></svg>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <ng-content></ng-content>
    <!-- <div class="media-details-container">
      <div class="media-details">
        <ng-container *ngTemplateOutlet="detailsTemplate() || defaultDetailsTemplate; context: { media }"></ng-container>
      </div>
    </div> -->
  </div>
</div>

<!-- <ng-template #defaultDetailsTemplate let-media="media">
  <h6 cCardTitle>{{ media.name }}</h6>
</ng-template> -->